<p class="graph-title font-primary--b">{{ title | translate }}</p>
<div
  class="graph-component"
  [class.unsubscribed]="!subscribed"
  [class.wideMode]="wideMode"
  *ngIf="!isEmpty"
>
  <ng-container
    *ngIf="
      chartCategory === 'psychometrics_personality' ||
      chartCategory === 'psychometrics_avk' ||
      chartCategory === 'psychometrics_emotional_regulation' ||
      chartCategory === 'psychometrics_career_anchors'
    "
  >
    <canvas
      #chartCanvas
      #{{chartId}}
      id="{{ chartId }}"
      width="1000"
      height="500"
    ></canvas>
    <!--<ul class="competencies-graph">
      <li class="item" *ngFor="let label of labels; index as i">
        <span class="label" [title]="label">
          {{ label }}
        </span>
        <div class="value-wrapper">
          <div
            class="value"
            [style]="
              'background-color:' +
              colors[0] +
              '; width:' +
              (100 * dataSets[i]) / 8 +
              '%'
            "
          ></div>
        </div>
      </li>
    </ul>-->
  </ng-container>
</div>
<div *ngIf="isEmpty">
  <h1 class="graph-title graph-title-no-data"> {{ "chartLabels.no-data" | translate}} </h1>
</div>
